import { type FC, useCallback } from 'react';

import { type NodeViewProps, NodeViewWrapper } from '@tiptap/react';

import { LinkEmbedRenderer } from '../LinkEmbedRenderer';

export const LinkEmbedView: FC<NodeViewProps> = ({ node, editor, deleteNode }) => {
  const { service, data } = node.attrs;

  const handleDelete = useCallback(() => deleteNode(), [deleteNode]);

  return (
    <NodeViewWrapper
      as="div"
      className="community-editor-link-embed-wrapper relative"
      data-drag-handle
      contentEditable={false}
    >
      <LinkEmbedRenderer service={service} data={data} />
      {editor.isEditable && (
        <button
          type="button"
          onClick={handleDelete}
          aria-label="Remove video"
          className="absolute right-2 top-2 inline-flex size-6 items-center justify-center rounded-full bg-black/70 text-white shadow-sm transition-colors hover:bg-black"
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
            <path d="M2.5 2.5L9.5 9.5M9.5 2.5L2.5 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </button>
      )}
    </NodeViewWrapper>
  );
};
